import { CartViewResponse } from "@jog/types"

import { handleCartError } from "../helper"
import { JoggApiOption } from "./client"

export const recalculateCartBase =
    ({ client }: Pick<JoggApiOption, "client">) =>
    async <S extends CartViewResponse>(cartId: string, version: number): Promise<S> => {
        const request = (version: number) => {
            return client.execute({
                method: "POST",
                uri: `/ctp/carts/${cartId}`,
                body: {
                    version,
                    actions: [
                        {
                            action: "recalculate",
                            updateProductData: true,
                        },
                    ],
                },
            })
        }
        return handleCartError(request, version, 5)
    }
